export default function removeNodes(setNodes, nodes, currentNode) {
  const filteredNodes = nodes.filter((item) => {
    return item.id !== currentNode.id;
  });
  setNodes(filteredNodes);
}
